import React, {useContext, useEffect, useState} from "react";
import Image from "components/Image/Image";
import {ProductTypeEnum} from "API";
import {CartContext} from "contexts/cart/cart.context";
import {ModalContext} from "contexts/modal.provider";
import {StockItemContext} from "contexts/stock/stock.provider";
import InputIncDec from "components/InputIncDec/InputIncDec";
import {cartAnimation} from "helper/utility";
import TripDatesModal from "containers/TripDatesModal/TripDatesModal";
import {AddToCartIcon} from "components/Icons";
import notifications from "utils/notifications";


export default function TWProductCard({product}) {
    const [pendingAdd, setPendingAdd] = useState(null);

    const [stockItems, setStockItems] = useState(null);
    const {
        add,
        getProductTripTotal,
        getProductPrice,
        update,
        cart: {products, tripDays, orderStartTime, orderEndTime, stockLocation}
    } = React.useContext(CartContext);
    const cartProduct = (product && products.find(p => p.id === product.id));
    const {getAvailableQty} = useContext(StockItemContext);
    const {openModal, closeModal} = useContext(ModalContext);

    useEffect(() => {
        if (orderStartTime && orderEndTime) {
            getAvailableQty(product.id, orderStartTime, orderEndTime, stockLocation)
                .then((rsp) => {
                    setStockItems(rsp);
                    if (pendingAdd) {
                        if (rsp > 0) {
                            document.getElementById(`related-add-${product.id}`).click();
                        } else {
                            notifications.info(`There are no available stock for your selected dates`, 8000);
                        }
                        setPendingAdd(null);
                    }
                });
        }
    }, [orderStartTime, orderEndTime]);

    const handleUpdate = (value: number) => {
        if (!cartProduct && value === 1) {
            add(product);
        } else {
            update(product.id, value);
        }
    };

    const handleClick = (e: any) => {
        e.stopPropagation();
        if (!orderStartTime) {
            setPendingAdd(true);
            openModal({
                content: <TripDatesModal onOk={closeModal}/>,
                classes: 'overflow-visible'
            });
        } else {
            const imageUrl = product.image?.url ?? (product.media && product.media.items[0] ? product.media.items[0].media?.url : null);

            if (imageUrl) {
                cartAnimation(e);
            }
            add(product);
        }
    };

    return (
        <div className="border rounded-lg p-2 cursor-pointer" onClick={handleClick}>
            <Image
                url={product.image?.url ?? (product.media && product.media.items[0] ? product.media.items[0].media?.url : null)}
                className='product-image rounded-t-lg object-contain w-full'
                style={{position: 'relative', height: 150}}
                alt={product.name}
            />
            <div className="">
                <div className="mt-1 truncate">
                    <span className="font-bold text-gray-900">{product.name}</span>
                </div>

                <div className="flex flex-col">
                    <div>

                        <h4 className="flex mt-1 text-gray-900 font-semibold text-lg">R{product.price}
                            <span className="inline-flex ml-1 text-sm text-gray-600">/day</span>
                        </h4>

                        {stockItems !== 0 && tripDays > 0 && product.type !== ProductTypeEnum.RETAIL_ITEM &&
                        <div className="my-1 w-full text-sm text-gray-700 font-semibold tracking-wide">
                            Trip: R {getProductTripTotal(product, cartProduct?.qty).total.toFixed(2)}
                        </div>
                        }

                        {
                            cartProduct?.qty >= stockItems &&
                            <div className="w-full text-red-500 text-xs tracking-wide">
                                Only {stockItems} item{stockItems > 1 ? 's' : ''} available
                            </div>
                        }
                    </div>
                    {stockItems !== 0 &&
                    <div className="flex items-center justify-center mt-2 mb-2">
                        {!cartProduct || cartProduct?.qty <= 0 ? (
                            <div id={`related-add-${product.id}`}>
                                <AddToCartIcon className="text-scuttle-orange w-6 h-6" onClick={handleClick}/>
                            </div>
                        ) : (
                            <InputIncDec
                                style={{
                                    height: 29
                                }}
                                disabled={cartProduct?.qty >= stockItems}
                                type={"horizontal"}
                                value={cartProduct?.qty}
                                onClick={(e: any) => {
                                    e.stopPropagation(onclick);
                                }}
                                onUpdate={(value: number) => handleUpdate(value)}
                            />
                        )}

                    </div>
                    }
                </div>


            </div>
        </div>
    );
}